import { MENTIONS_QUERY_CUSTOM_KEY, createCustomMetric } from '@confluence/browser-metrics';
export const MENTIONS_QUERY_METRIC = createCustomMetric({
	key: MENTIONS_QUERY_CUSTOM_KEY,
});
